// #region CONSTANTES
export const RESSOURCE_ACHATS = "achats";
export const RESSOURCE_PRE_ACHATS = "pre_achats";
export const RESSOURCE_PRE_ACHATS_UTILISATEUR = "pre_achats/utilisateur";
export const RESSOURCE_DETAIL_ACHATS = "pre_detail_achats";
export const RESSOURCE_DISTRIBUTION = "distribution";
export const RESSOURCE_DISTRIBUTION_UTILISATEUR = "pre_detail_achats/utilisateur_valides";
export const RESSOURCE_HISTO_ACHATS = "pre_achats/utilisateur?statusPayzen=00&_order%5BdateSysteme%5D=desc";
export const RESSOURCE_SERVICES = "services";
export const RESSOURCE_TARIFS = "tarifs";
export const RESSOURCE_TERMINAL_ETAT = "terminalEtat";
export const RESSOURCE_ZONE = "zone_terminals";
// #endregion
